import { Typography, Box, Card, CardContent, Grid } from "@mui/material";
import { TrendingUp, People, Event } from "@mui/icons-material";

/**
 * Dashboard page demonstrating the app layout with navigation.
 */
export function DashboardPage() {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        This page demonstrates the full app layout with navigation drawer
      </Typography>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Card>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                <TrendingUp color="primary" fontSize="large" />
                <Typography variant="h6">Analytics</Typography>
              </Box>
              <Typography variant="h3" color="primary" gutterBottom>
                1,234
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total events this month
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Card>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                <People color="secondary" fontSize="large" />
                <Typography variant="h6">Users</Typography>
              </Box>
              <Typography variant="h3" color="secondary" gutterBottom>
                42
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Active users today
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Card>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                <Event color="info" fontSize="large" />
                <Typography variant="h6">Events</Typography>
              </Box>
              <Typography variant="h3" color="info.main" gutterBottom>
                8
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Scheduled for this week
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
